module.exports = {
  // qcost
  qcostInterface: 'http://sz.qcost.isd.com',
  qcostInterfacePort: 80,

  appLocals: {
    QCLOUD_DOMAIN: 'www.qcloud.com',
    CONSOLE_DOMAIN: 'console.qcloud.com',
    CSS_DOMAIN: 'cloudcache.tencent-cloud.com',
    // 'CSS_DOMAIN': 'imgcache.qq.com',
  },

  // qcost
  qcostInterface: 'http://sz.qcost.isd.com',
  qcostInterfacePort: 80,

  // 海外 CDN 域名配置
  intlCdnHost: 'cloudcache.tencent-cloud.com',

  commonInterface: 'http://test.api.qcintl.woa.com',

  // 云api
  capiInterface: 'test.api.tencentyun.com',

  // 云api 3.0
  capiInterfaceV3: 'test.ap-guangzhou.api.tencentyun.com',

  // 新临时密钥
  stsInterface: 'http://test.sts.tencentyun.com',

  // mcproxy
  // mcproxyInterface: 'http://test.mcproxy.tencentyun.com/interface.php',
  mcproxyInterface: 'http://test.sg.intl.mcproxy.tencentyun.com/interface.php',

  // 校验验证码接口
  verifyCaptchaInterface: 'http://mcproxy.isd.com/VerifyCode.php',

  // 新注册接口
  newAccountInterface: 'http://test.api.qcintl.woa.com',

  // account
  // accountInterface: 'http://test.account.tencentyun.com',
  accountInterface: 'http://test.sg.intl.account.tencentyun.com',

  // waccount
  // waccountInterface: 'http://test.waccount.tencentyun.com',
  waccountInterface: 'http://test.sg.intl.waccount.tencentyun.com',

  partnerInterface: 'http://test-intlchannel.woa.com',

  // cache
  cacheInterface: 'http://test.cache.tencentyun.com',

  // connect
  // connectInterface: 'http://test.connect.tencentyun.com',
  connectInterface: 'http://test.sg.intl.connect.tencentyun.com',

  // CGW <现网>
  mcGatewayInterface: 'http://cgateway.tencentyun.com/interfaces/interface.php', // 默认
  mcGatewayInterface_gz: 'http://gz.cgateway.tencentyun.com/interfaces/interface.php', // 广州
  mcGatewayInterface_sh: 'http://sh.cgateway.tencentyun.com/interfaces/interface.php', // 上海
  mcGatewayInterface_shjr: 'http://shjr.cgateway.tencentyun.com/interfaces/interface.php', // 上海金融专区
  mcGatewayInterface_bj: 'http://bj.cgateway.tencentyun.com/interfaces/interface.php', // 北京
  mcGatewayInterface_hk: 'http://hk.cgateway.tencentyun.com/interfaces/interface.php', // 香港
  mcGatewayInterface_ca: 'http://ca.cgateway.tencentyun.com/interfaces/interface.php', // 北美
  mcGatewayInterface_sg: 'http://sg.cgateway.tencentyun.com/interfaces/interface.php', // 新加坡
  mcGatewayInterface_szjr: 'http://szjr.cgateway.tencentyun.com/interfaces/interface.php', // 深圳金融
  mcGatewayInterface_gzopen: 'http://gzopen.cgateway.tencentyun.com/interfaces/interface.php', // 广州 Open
  mcGatewayInterface_usw: 'http://usw.cgateway.tencentyun.com/interfaces/interface.php', // 美国西部（硅谷）
  mcGatewayInterface_cd: 'http://cd.cgateway.tencentyun.com/interfaces/interface.php', // 成都
  mcGatewayInterface_de: 'http://de.cgateway.tencentyun.com/interfaces/interface.php', // 德国法兰克福
  mcGatewayInterface_kr: 'http://kr.cgateway.tencentyun.com/interfaces/interface.php', // 韩国首尔
  mcGatewayInterface_cq: 'http://cq.cgateway.tencentyun.com/interfaces/interface.php', // 重庆

  // logic server
  // logicInterface: 'http://test.logical.server.console.tencentyun.com/interface.php',
  logicInterface: 'http://test.sg.intl.logical.server.console.tencentyun.com/interface.php',

  // mfa
  // mfaInterface: 'http://test.mfa.tencentyun.com',
  mfaInterface: 'http://test.sg.intl.mfa.tencentyun.com',

  // midas
  midasInterface: 'http://test.api-gateway-intl.billing.tencentyun.com',

  // open
  // openInterface: 'http://test.open.tencentyun.com',
  openInterface: 'http://test.sg.intl.open.tencentyun.com',

  opcInterface: 'http://opc.tencentyun.com', // 运营平台中心接口现网环境

  reportlogInterface: 'http://reportlog.tencentyun.com', // 现网

  // message
  messageInterface: 'http://test.message.tencentyun.com', // 现网

  seoInterface: 'http://test.seo.tencentyun.com',

  // 发送短信邮件接口
  cmsiInterface: 'http://test.cmsi.tencentyun.com/interface.php',

  // 新告警接口
  // @see http://tapd.oa.com/QCloud_2015/markdown_wikis/view/#1010103951006601871
  cmsiTofInterface: 'http://tof.cmsi.tencentyun.com:50015',

  opcBackendInterface: 'http://opc-backend.tencentyun.com',

  logicForPartnerInterface: 'http://test.api.qcintl.tencentyun.com/PartnerAccount', // 经销商

  backendRebateYunapi: 'http://test.api.qcintl.woa.com/backend-partner/yunapi/trpc', // 经销商云api
  // 安全服务域名
  // securityInterface: 'http://test.api.qcintl.woa.com/security-services',
  securityInterface: 'http://test.api.qcintl.woa.com/intl-security-services',

  // 账号风控服务
  accountRiskControl: 'https://test.api.qcintl.woa.com/account-backend-account-risk-management',

  // 内容相关：搜索，文档中心
  contentInterface: 'http://test.content.tencentyun.com/interface.php', // 联调

  // cms
  opm: 'http://dev.qcloudintlbackend.tencentyun.com/api/tool',

  // cms接口配置
  opmConfig: {
    registerSuccessActivityPId: 376,
    registerSuccessDiscountPId: 390,
    registerLatestProductsPId: 399,
    registerTrialProductSmallPId: 404,
    registerTrialProductBigPId: 401,
    registerDiscountPId: 389,
    loginIntroducePId: 391,
    loginIntroduceCId: 2729,
  },
};
